import React from "react";
import Pricing from "../Pricing";
import { Route, Routes } from "react-router-dom";
import Home from "../Home";
import Features from "../Features";
import Contact from "../Contact";



function Content() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

    </div>
  );
}

export default Content;